module.exports = __webpack_public_path__ + "media/images/lb/371-6a69f98e56dcded2c108b18ab5316e6d.svg";